import 'ui-theme/components/sections-navbar/js/sections-navbar';

const {sidebarSections} = UX || {};

if (sidebarSections?.get?.fixedpageElementsHeight) {
    sidebarSections.get.fixedpageElementsHeight = () => {
        const header = $('header');
        const secondaryMenu = $('#js-secondary-menu');
        let elementsHeight =
            header.css('position') === 'fixed' || header.css('position') === 'sticky' ? header.outerHeight() : 0;
        elementsHeight += secondaryMenu.length ? secondaryMenu.height() : 0;
        $('.actionsbar').each(function () {
            const _this = $(this);
            if (_this.outerHeight() > 0) {
                elementsHeight += _this.outerHeight();
            }
        });
        return elementsHeight;
    };
}
